import { render, staticRenderFns } from "./HomeBase.vue?vue&type=template&id=040ccaf2&scoped=true"
import script from "./HomeBase.vue?vue&type=script&lang=js"
export * from "./HomeBase.vue?vue&type=script&lang=js"
import style0 from "./HomeBase.vue?vue&type=style&index=0&id=040ccaf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040ccaf2",
  null
  
)

export default component.exports